import { useState, useEffect } from 'react';
import { mobilePushApi } from '../services/api/mobile-push.api';

export const useVapidKey = () => {
  const [publicKey, setPublicKey] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchPublicKey = async () => {
      try {
        setLoading(true);
        setError(null);
        const key = await mobilePushApi.getPublicKey();
        setPublicKey(key);
      } catch (err) {
        setError(err as Error);
        console.error('[VAPID] Ошибка получения публичного ключа:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPublicKey();
  }, []);

  return { publicKey, loading, error };
};

